<template>
    <section class="space-y-6">
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <FormInput
                :model-value="client.name"
                :label="t('reservation.step3.fullName')"
                required
                :show-error="attemptedNext && !client.name"
                :error="attemptedNext && !client.name ? tNameRequired : ''"
                class="sm:col-span-2"
                @update:model-value="updateField('name', $event)"
            />
            <FormInput
                :model-value="client.email"
                :label="t('reservation.step3.email')"
                type="email"
                required
                :show-error="attemptedNext && (!client.email || !emailHasAt)"
                :error="attemptedNext && !client.email ? tEmailRequired : attemptedNext && !emailHasAt ? tEmailInvalid : ''"
                @update:model-value="updateField('email', $event)"
            />
            <FormInput
                :model-value="client.phone"
                :label="t('reservation.step3.phone')"
                type="tel"
                :hint="t('reservation.step3.phoneHint')"
                @update:model-value="updateField('phone', $event)"
            />
            <FormTextarea
                :model-value="client.notes"
                :label="t('reservation.step3.notes')"
                class="sm:col-span-2"
                @update:model-value="updateField('notes', $event)"
            />
        </div>
    </section>
</template>

<script setup lang="ts">
import FormInput from '@/Components/Molecules/FormInput.vue';
import FormTextarea from '@/Components/Molecules/FormTextarea.vue';
import { useTranslations } from '@/composables/useTranslations';
import { computed } from 'vue';

const { t } = useTranslations();

interface ClientInfo {
    name: string;
    email: string;
    phone: string;
    notes: string;
}

interface Props {
    client: ClientInfo;
    attemptedNext?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    (e: 'update:client', value: ClientInfo): void;
}>();

const tNameRequired = t('reservation.step3.requiredName');
const tEmailRequired = t('reservation.step3.requiredEmail');
const tEmailInvalid = t('reservation.step3.invalidEmail');
const emailHasAt = computed(() => props.client.email?.includes('@'));

// Update individual field
const updateField = (field: keyof ClientInfo, value: string) => {
    emit('update:client', { ...props.client, [field]: value });
};
</script>
